// extracted by mini-css-extract-plugin
export var chevron = "_ld-2";
export var chevronRotated = "_ld-3";
export var header = "_ld-1";
export var section = "_ld-0";